import { Outlet } from 'react-router-dom';
import { ObjectProvider } from 'components/ObjectsList/context/ObjectProvider';

const ObjectWrapper = () => {
  return (
    <ObjectProvider>
      <Outlet />
    </ObjectProvider> 
  );
};

export default ObjectWrapper;